import React from 'react';
import { Search, ArrowUpDown } from 'lucide-react';

const SORT_OPTIONS = [
  { value: 'last_activity_at', label: 'Recently Active' },
  { value: 'created_at', label: 'Date Created' },
  { value: 'name', label: 'Name (A-Z)' },
];

const CustomerSearch = ({ searchTerm, onSearchChange, sortBy, onSortChange }) => {
  return (
    <div className="p-4 border-b border-gray-200">
      <div className="flex items-center gap-3">
        <div className="relative flex-1 max-w-md">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
          <input
            type="text"
            placeholder="Search customers..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pest-blue focus:border-transparent"
          />
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <ArrowUpDown size={15} className="text-gray-400" />
          <select
            value={sortBy}
            onChange={(e) => onSortChange(e.target.value)}
            className="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 bg-white focus:ring-2 focus:ring-pest-blue focus:border-transparent cursor-pointer"
          >
            {SORT_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default CustomerSearch;